module.exports = __webpack_public_path__ + "static/media/pixel-art-maker-alt.0130afd0.png";